export const trimBidiControlChars = (input: string) => {
	const bidiControlChars = /[\u202A-\u202E\u200E\u200F\u2066-\u2069]/g

	return input.replace(bidiControlChars, '')
}